import React from "react";
import { connect } from "react-redux";
import BlockPlafond from "./BlockPlafond";
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import PieChart from "../Base/PieChart";
import PropTypes from 'prop-types';
import InfoGeoloc from "./InfoGeoloc";

class HomeBtf extends React.Component {


    render() {
        console.log(this.props.currentClient)
        let dataEnseigne = undefined
        if (this.props.encoursEnseigne !== undefined) {
            dataEnseigne = this.props.encoursEnseigne
        }
        let dataProduit = undefined
        if (this.props.encoursProduits !== undefined) {
            dataProduit = this.props.encoursProduits
        }
        return (
            <>
                <div className="row gy-4">

                    <div className="col-xl-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                        {this.props.encoursEnseigne !== undefined ?
                            <BlockPlafond  {...this.props} />
                            : null
                        }
                    </div>


                    <PieChart className="col-xl-6 col-md-6 aos-init aos-animate" title='- REPARTITION PAR ENSEIGNE -' data={dataEnseigne} />
                    <PieChart className="col-xl-6 col-md-6 aos-init aos-animate" title='- REPARTITION PAR PRODUIT -' data={dataProduit} />
                    <InfoGeoloc isAxodel={this.props.currentClient.isAxodel} isQuartix={this.props.currentClient.isQuartix}/>
                </div>

                {!this.props.parrain.startsWith('SYM') && !this.props.parrain.startsWith('enpc')?
                    <>
                        <div className="row gy-4">
                            <div style={{ display: 'block', width: '100%' }}>
                                <div className='titleAvantage' style={{ width: '300px', margin: 'auto', paddingTop: '20px' }}>
                                    <b>MES AVANTAGES OFFERTS PAR BTF</b>
                                </div>
                            </div>
                        </div>
                        <div className="row gy-4">
                            <div className="col-xl-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                                <div className='HomeBlock'  >
                                    <Link to='https://adherents.reducbox.com/login' target='_blank' >
                                        <img src='/assets/images/reducbox.png' alt='' style={{ width: '100%', height: '100%' }} />
                                    </Link>
                                    
                                </div>
                            </div>
                            <div className="col-xl-6 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500">
                                <div className='HomeBlock' >
                                    <Link
                                        to={"https://reducpro.fr/?token=" + jwtDecode(this.props.JWTToken).ssoreducpro + "&service=sso&pclient=btf&pkclient=1D2y4edYet5ddYZedrg1"}
                                        target='_blank'
                                    >
                                        <img src='/assets/images/reducpro.png' alt='' style={{ width: '100%', height: '100%' }} />
                                    </Link>
                                    
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    null
                }
            </>
        )
    }
}


const mapStateToProps = (state) => {
    return ({
        JWTToken: state.authentication.JWTToken,
        encoursProduits: state.app.encoursProduits,
        encoursEnseigne: state.app.encoursEnseigne,
        plafond: state.app.plafond,
        parrain: state.app.parrain,
        currentClient: state.authentication.currentClient,

    })
}

HomeBtf.propTypes = {
    JWTToken: PropTypes.string,
    encoursProduits: PropTypes.array,
    encoursEnseigne: PropTypes.array,
    plafond: PropTypes.number || PropTypes.string,
    parrain: PropTypes.string,
    currentClient: PropTypes.object
};

export default connect(mapStateToProps)(HomeBtf);
